export enum EnvironmentType {
  DEV = 'DEV',
  PROD = 'PROD',
  QA = 'QA'
}
